<app-advanced-search (requestDtoEvent)="requestDtoChanged($event)"></app-advanced-search>

<div class="text-end mb-3 w-100 d-flex align-items-center justify-content-between search-result-tab">
    <mat-card class="light-yellow-label mat-elevation-z0 w-100 d-flex justify-content-between">
        <button
            class="bg-transparent text-blue font-12 mat-elevation-z0 float-start no-hover-bg-color line-height-25 px-3 me-5"
            mat-button mat-raised-button (click)="jobDashBoard()">
            <mat-icon class="material-icons-outlined me-2 mat-icon-14" mat-list-icon>arrow_back_ios</mat-icon> Back to
            home
        </button>
        <div class="sort-drop-down">
        <app-advanced-search-sort-drop-down (sortChanged)="onSortChanged($event)" 
            [defaultSortOrder]="selectedSortOrder" [defaultSortOption]="selectedSortOption"
            [isFilterdJobListAvailable]="isFilterdJobListAvailable">
        </app-advanced-search-sort-drop-down>
        </div>
        <mat-form-field appearance="outline" class="pb-0 w-100px">
            <mat-label>Show Results</mat-label>
            <mat-select [(value)]="advanceSearch.pageSize">
                <mat-option *ngFor="let number of [20,50,100]" [value]="number"
                    (onSelectionChange)="onNumberOfResultsPerPageChange($event)">{{
                    number }}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
</div>
<mat-card class="mat-elevation-z0" *ngIf="!filteredJobList && !isLoad && advanceSearch?.isApply">
    <app-common-loader></app-common-loader>
</mat-card>
<app-advanced-filtered-jobs-display [jobList]="filteredJobList" [isApply]="advanceSearch?.isApply" (clickRow)="onclickRow($event)"
    *ngIf="isLoad && filteredJobList">
</app-advanced-filtered-jobs-display>
<div *ngIf="filteredJobList">
    <mat-paginator style-paginator (page)="pageChangeEvent($event)" [length]="totalRowCount"
        [pageSize]="advanceSearch.pageSize" [showTotalPages]="3" showFirstLastButtons [pageIndex]="pageIndex">
    </mat-paginator>
</div>